<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute md-orange t_header-top"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <!-- <h3 class="md-title">Orange Tree</h3> -->
        <a target="_self" href="/">
          <img :src="logoUrl" alt="Orange Tree">
        </a>
      </div>
      <div class="md-toolbar-section-end t_section-center">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item target="_self" href="/meetingRooms">
                <i class="material-icons">meeting_room</i>
                <p>Meeting Rooms</p>
              </md-list-item>

              <md-list-item target="_self" href="/guestRooms">
                <i class="material-icons">local_hotel</i>
                <p>Guest Rooms</p>
              </md-list-item>

              <md-list-item target="_self" href="/kitchen">
              <!-- <md-list-item target="_self" href="/index" v-if="showDownload"> -->
                <i class="material-icons">restaurant</i>
                <p>Restaurant</p>
              </md-list-item>

              <md-list-item target="_self" href="/packages">
                <i class="material-icons">shop_two</i>
                <p>Packages</p>
              </md-list-item>

              <md-list-item target="_self" href="/activities">
                <i class="material-icons">local_activity</i>
                <p>Activities</p>
              </md-list-item>

              <md-list-item target="_self" href="/contactus">
                <i class="material-icons">contacts</i>
                <p>Contact</p>
              </md-list-item>
              <!-- <md-list-item target="_self" href="/aboutus">
                <i class="material-icons">people</i>
                <p>About Us</p>
              </md-list-item> -->

              <!-- <md-list-item
                target="_self" href="https://demos.creative-tim.com/vue-material-kit/documentation/"
               
                v-if="showDownload"
              >
                <i class="material-icons">content_paste</i>
                <p>Documentation</p>
              </md-list-item>

              <md-list-item
                target="_self" href="javascript:void(0)"
                @click="scrollToElement()"
                v-if="showDownload"
              >
                <i class="material-icons">cloud_download</i>
                <p>Download</p>
              </md-list-item> -->

            </md-list>
          </div>
        </div>
      </div>
      <div class="md-toolbar-section-end" style="justify-content: center;">
        <a class="t_daysinn" target="_self" href="/guestRooms">
          <img :src="daysinnLogoUrl" alt="Days Inn Sherman">
          <span>Hotel & Banquet Halls</span>
        </a>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "orange",
          "info"
        ].includes(value)
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logoUrl: {
      type: String,
      default: require("@/assets/img/smallLogo1.png")
    },
    daysinnLogoUrl: {
      type: String,
      default: require("@/assets/img/daysinnLogo.png")
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false
    }
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"]
      return excludedRoutes.every(r => r !== this.$route.name)
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick")

      if (bodyClick === null) {
        let body = document.querySelector("body")
        let elem = document.createElement("div")
        elem.setAttribute("id", "bodyClick")
        body.appendChild(elem)

        let bodyClick = document.getElementById("bodyClick")
        bodyClick.addEventListener("click", this.toggleNavbarMobile)
      } else {
        bodyClick.remove()
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar
      this.toggledClass = !this.toggledClass
      this.bodyClick()
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop
      let navbarColor = document.getElementById("toolbar")
      this.currentScrollValue = scrollValue
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`
        navbarColor.classList.remove("md-transparent")
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = ""
          navbarColor.classList.add("md-transparent")
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll)
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection")
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" })
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener)
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener)
  }
};
</script>

<style scoped lang="scss">
.t_section-center{
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-box-align: center;
  box-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -ms-box-flex: 1;
  box-flex: 1;
  flex: 1;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-box-pack: center;
  box-pack: center;
  justify-content: center;
  -webkit-box-ordinal-group: 9;
  -moz-box-ordinal-group: 9;
  -ms-box-ordinal-group: 9;
  box-ordinal-group: 9;
  order: 9;
}
.t_header-top{
  padding-top: 15px !important;
}
.t_daysinn{
  text-align: center;
  img{
    width: 80px;
    height: auto;
  }
  span{
    display: block;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
  }
}
</style>